import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { useStore } from 'vuex'
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter'
import purchaseRegisterColumns from '@/services/utils/purchaseRegisterColumns'

pdfMake.vfs = pdfFonts.pdfMake.vfs

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

const pdfPrinter = () => {
    const store = useStore()
    const { getHeader, getFooter } = pdfHeaderFooter()
    const { getColumns, getTitle, isNumeric, formatCell, formatTotal } = purchaseRegisterColumns()

    const userName = store.state.user.user.name

    const exportToPDF = (company, registerData, tab, startDate = '', endDate = '') => {
        const title = `${getTitle(tab)} (${startDate} to ${endDate})`
        const doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            pageOrientation: 'landscape',
            header: getHeader(company),
            footer: getFooter(userName),
            content: [
                getTitleBlock(title),
                getTableBlock(registerData, tab)
            ],
            defaultStyle: {
                color: 'black',
                fontSize: 7,
                font: 'SulaimanLipi'
            },
            info: {
                title: title
            }
        }

        pdfMake.createPdf(doc).open()
    }

    const getTitleBlock = (title) => {
        return {
            text: title,
            alignment: 'center',
            margin: [0, 0, 20, 10],
            bold: true,
            fontSize: 12,
            decoration: 'underline'
        }
    }

    const getTableBlock = (registerData, tab) => {
        const columns = getColumns(tab)
        const rows = registerData.data.data
        return {
            margin: [0, 10, 0, 0],
            table: {
                headerRows: 1,
                widths: getWidths(columns),
                body: [
                    getHeaderRow(columns),
                    ...rows.map((row, index) => getBodyRow(row, index, columns)),
                    getTotalRow(registerData.total, columns)
                ]
            },
            layout: {
                fillColor: (rowIndex) => {
                    if (rowIndex === 0) return '#f3f2f7'
                    return null
                },
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5
            }
        }
    }

    const getWidths = (columns) => {
        return ['auto'].concat(columns.map(column => {
            if (isNumeric(column)) return 'auto'
            return '*'
        }))
    }

    const getAlignment = (column) => {
        if (isNumeric(column)) return 'right'
        return 'left'
    }

    const getHeaderRow = (columns) => {
        return [{ text: 'SL#', bold: true }].concat(columns.map(column => {
            return { text: column.label, bold: true, alignment: getAlignment(column) }
        }))
    }

    const getBodyRow = (row, index, columns) => {
        return [{ text: index + 1 }].concat(columns.map(column => {
            return { text: String(formatCell(row, column)), alignment: getAlignment(column) }
        }))
    }

    const getTotalRow = (totals, columns) => {
        return [{ text: 'Total', bold: true }].concat(columns.map(column => {
            return { text: String(formatTotal(totals, column)), bold: true, alignment: getAlignment(column) }
        }))
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter
